import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "app",
  class: "app-content"
};
const _hoisted_2 = {
  class: "app-url"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "app-contant"
}, [/*#__PURE__*/_createTextVNode(" 邮箱地址："), /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:kwokbunlo@gmail.com"
}, "kwokbunlo@gmail.com")], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");

  const _component_van_field = _resolveComponent("van-field");

  const _component_van_button = _resolveComponent("van-button");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: $data.isWx,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.isWx = $event),
    class: "overlay-bg",
    position: "bottom",
    style: {
      height: '100%'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_van_image, {
      src: $data.downBg,
      fit: "contain"
    }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.url,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.url = $event),
        rows: "1",
        autosize: "",
        label: "网址",
        type: "textarea"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_button, {
        type: "primary",
        block: "",
        onClick: _ctx.copyUrl
      }, {
        default: _withCtx(() => [_createTextVNode("复制")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_router_view), _hoisted_3]);
}